import { createContext, useContext } from "react";

/**
 * Holds the identity token carried by the `/verify/:token` link (marco B). Kept in memory only — never
 * persisted to localStorage. `VerificationService` reads it per request to authenticate the public flow. The
 * Provider is applied directly in `VerificationLinkRoute` via `VerificationTokenContext.Provider`.
 */
export const VerificationTokenContext = createContext<string | null>(null);

export function useVerificationToken(): string {
  const token = useContext(VerificationTokenContext);
  if (!token) {
    throw new Error("useVerificationToken must be used within a VerificationTokenContext provider");
  }
  return token;
}
